import { OptionDto } from "@/dtos";
import { TripPatternCheckpointGeofenceMark } from "@/helpers/types";

const geofenceMarks = [
    { value: TripPatternCheckpointGeofenceMark.FIRST, label: 'Primero' },
    { value: TripPatternCheckpointGeofenceMark.LAST, label: 'Último' },
] as OptionDto[];

export const getTripPatternCheckpointGeofenceMarkOptions = (): OptionDto[] => {
    return geofenceMarks;
}

export const getTripPatternCheckpointGeofenceMarkOption = (value?: number): OptionDto => {
    return geofenceMarks.find((x) => x.value == value) ?? geofenceMarks[0];
}